import { initializeApp } from "firebase/app";
import {
  getAuth,
  sendPasswordResetEmail,
  signOut,
  confirmPasswordReset,
  reauthenticateWithCredential,
  updatePassword,
  EmailAuthProvider,
} from "firebase/auth";
import { toast } from "react-toastify";
import {
  FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN,
  FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET,
  FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_APP_ID,
  FIREBASE_MEASUREMENT_ID,
  Activity,
  currentRequestTimeStamp,
} from "../../Constants";

const firebaseConfig = {
  apiKey: FIREBASE_API_KEY,
  authDomain: FIREBASE_AUTH_DOMAIN,
  projectId: FIREBASE_PROJECT_ID,
  storageBucket: FIREBASE_STORAGE_BUCKET,
  messagingSenderId: FIREBASE_MESSAGING_SENDER_ID,
  appId: FIREBASE_APP_ID,
  measurementId: FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase and Firebase Authentication
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const sendPasswordReset = async (email) => {
  try {
    Activity(
      [
        {
          screen: "forget password",
          module: "lorriheader",
          user_activity: `User clicked forgot password`,
          timestamp: currentRequestTimeStamp(),
        },
      ],
      "Password Reset Request",
      email,
    );
    await sendPasswordResetEmail(auth, email);
    alert("Password reset link sent!");
    window.location.href = "/login";
  } catch (err) {
    console.error(err.message, "62");
    if (err.message === "Firebase: Error (auth/user-not-found).") {
      alert("User does not exists. Please Sign Up!");
    }
  }
};

const changePassword = async (
  currentPassword,
  newPassword,
  confirmPassword,
  setError,
  setShow,
) => {
  setShow(true);
  try {
    if (newPassword !== "" && confirmPassword !== "") {
      if (newPassword !== confirmPassword) {
        setError("Confirm password does not match");
        setShow(false);
      } else if (
        currentPassword === newPassword ||
        currentPassword === confirmPassword
      ) {
        setError("Same Password");
        setShow(false);
      } else {
        const user = auth.currentUser;
        const credentials = EmailAuthProvider.credential(
          user.email,
          currentPassword,
        );
        await reauthenticateWithCredential(user, credentials);
        await updatePassword(user, newPassword);
        TrackMixPanel({
          ModuleName: "lorri header",
          ScreenName: "change password",
          Data: `email : ${user.email}`,
          Definition: "user has updated password",
        });
        toast.success("Password has been updated");
        setShow(false);
        logout();
      }
    } else {
      alert("Please enter password");
      setShow(false);
    }
  } catch (err) {
    setError("Invalid password");
    setShow(false);
    console.log(err);
  }
};

const sendPasswordForgot = async (oobCode, password, confirmpassword) => {
  try {
    if (password !== "" && confirmpassword !== "") {
      if (password !== confirmpassword) {
        alert("Confirm Password does not match");
      } else {
        await confirmPasswordReset(auth, oobCode, password);
        alert("Password reset successfully!");
        window.location.href = "/login";
      }
    }
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const logout = (auth) => {
  signOut(auth)
    .then(() => {
      // window.location.href = "/";
      sessionStorage.clear();
      localStorage.clear();
      history.pushState("", "", "/login");
    })
    .catch((error) => {
      console.error("Error during logout:", error);
    });
};

export { auth, sendPasswordReset, logout, sendPasswordForgot, changePassword };
